import React from "react";

import { OrganizationMusicStatsContainer } from "../../location/musicStatistics/OrganizationMusicStatsContainer";
const OrganizationMusicStatisticsRoute = (props) => {
    const organizationIdRaw = props?.match?.params?.organizationID;

    const organizationId = organizationIdRaw
        ? parseInt(organizationIdRaw, 10)
        : 0;

    return (
        <div className="container">
            <OrganizationMusicStatsContainer organizationId={organizationId} />
        </div>
    );
};

export default OrganizationMusicStatisticsRoute;
